// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeContent from "./HomeContent.re.mjs";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SocialProofSection from "./SocialProofSection.re.mjs";
import * as RescriptRelay_Fragment from "rescript-relay/src/RescriptRelay_Fragment.re.mjs";
import * as HomeReviews_query_graphql from "../../../__generated__/HomeReviews_query_graphql.re.mjs";
import * as RescriptRelay_TestFragmentRef from "rescript-relay/src/RescriptRelay_TestFragmentRef.re.mjs";

import { t } from '@lingui/macro'
;

let convertFragment = HomeReviews_query_graphql.Internal.convertFragment;

function fromData(data) {
  return RescriptRelay_TestFragmentRef.make("HomeReviews_query", data);
}

let Test = {
  fromData: fromData
};

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, HomeReviews_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(HomeReviews_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, HomeReviews_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(HomeReviews_query_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  Test: Test,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function HomeReviews(props) {
  let data = RescriptRelay_Fragment.useFragment(HomeReviews_query_graphql.node, convertFragment, props.query);
  let reviews = data.featuredReviews.map(review => {
    let reviewer = review.reviewerName;
    return {
      quote: HomeContent.truncateReview(review.text),
      name: HomeContent.reviewerAttribution(review.reviewerName, review.city, review.country),
      date: Stdlib_Option.mapOr(review.reviewDate, "", HomeContent.formatDate),
      rating: review.rating,
      image: review.image,
      alt: t`Painting reviewed by ${reviewer}`,
      link: HomeContent.orderLink(review.sku, review.orderId)
    };
  });
  return JsxRuntime.jsx(SocialProofSection.make, {
    reviews: reviews,
    totalCount: data.totalReviewsCount
  });
}

let make = HomeReviews;

export {
  Fragment,
  make,
}
/*  Not a pure module */
